module.exports = __webpack_public_path__ + "static/favicon-2660483585d9fa1c1101433235f90f0a.ico";